import { render } from "./ProductCarousel.vue?vue&type=template&id=b0e7feea&scoped=true&ts=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=ts"
export * from "./ProductCarousel.vue?vue&type=script&lang=ts"

import "./ProductCarousel.vue?vue&type=style&index=0&id=b0e7feea&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e7feea"]])

export default __exports__